import React, { useEffect, useRef, useState } from "react";
import "../Forgot.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { FaChevronLeft } from "react-icons/fa6";
import { useForm } from "react-hook-form";
import FormInputField from "../../../components/UserFormComponents/FormInputField/FormInputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { resetPasswordOfForgotPassword } from "../../../api/auth";
import { toast } from "react-toastify";
import DesktopLoginContents from "../../../components/DesktopLoginContents/DesktopLoginContents";
import { Capacitor } from "@capacitor/core";
import Captcha from "../../../components/Captcha/Captcha";
import { useSelector } from "react-redux";

const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const reRef = useRef();
  const location = useLocation();

  const credentials = location.state?.credentials || {};

  const user = useSelector((state) => state.userReducer.value);

  useEffect(() => {
    if (user.token) {
      navigate(ROUTES.home.path);
    }
  }, []);

  useEffect(() => {
    if (!credentials?.email || !credentials?.otp) {
      navigate(ROUTES.forgotPassword.path);
    }
  }, [credentials]);

  const handleResetPassword = async (data) => {
    if (data?.password === data?.confirmPassword) {
      setSubmitting(true);
      let captchaToken = "";
      let source = "";
      if (Capacitor.isNativePlatform()) {
        source = "mobile";
      } else {
        captchaToken = await reRef.current.executeAsync();
      }
      const userData = {
        email: credentials?.email,
        otp: credentials?.otp,
        password: data?.password,
        password_confirmation: data?.confirmPassword,
        captchaToken: captchaToken,
        source: source,
      };

      resetPasswordOfForgotPassword(userData)
        .then((res) => {
          if (res.data?.message) {
            toast.dismiss(); toast.success(res.data?.message);
          } else {
            toast.dismiss(); toast.success("Password reset successfully.");
          }
          navigate(ROUTES.login.path);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss(); toast.error("Password reset failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      setError("confirmPassword", {
        type: "custom",
        message: "Confirm password doesnot match with above password!",
      });
    }
  };
  return (
    <>
      <Captcha reRef={reRef} />
      <div className="initial-page-contents">
        <div className="forgot-page">
          <form
            onSubmit={handleSubmit(handleResetPassword)}
            className="form-container"
          >
            <div className="upper">
              <Link to={ROUTES.login.path} className="go-back">
                <FaChevronLeft />
              </Link>
              <div className="heading">
                <p className="title">
                  Reset <br />
                  <span>Password</span>
                </p>
                <p className="message">
                  The Password for <span>{credentials?.email}</span> must be
                  different from before.
                </p>
              </div>

              <div className="inputs">
                <FormInputField
                  name={"password"}
                  label={"Create new password"}
                  type={"password"}
                  iconType={"password"}
                  required={true}
                  watch={watch}
                  register={register}
                  inputErrors={errors}
                />
                <FormInputField
                  name={"confirmPassword"}
                  label={"Re-type your password"}
                  type={"password"}
                  iconType={"password"}
                  required={true}
                  watch={watch}
                  register={register}
                  inputErrors={errors}
                />
              </div>
            </div>

            <div className="lower">
              <CustomButton
                name={"Reset Password"}
                type={"submit"}
                color={"white reverse"}
                bigButton={true}
                disabled={submitting}
                handleSubmit={() => {}}
                loader={submitting}
              />

              <p className="company-tag">
                &copy; Daikofin <span></span>
                <Link to={ROUTES.contactDUS.path}>Contact</Link>
                <span></span>
                <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                  Privacy & terms
                </a>
              </p>
            </div>
          </form>
        </div>
        <DesktopLoginContents />
      </div>
    </>
  );
};

export default ResetPassword;
